import { RootState } from "../Store";

export const SELECT_APPLICATIONS_DATA_TO_BANK = (state: RootState) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK;

export const SELECT_APPLICATIONS_DATA_TO_BANK_MEMBER_FL = (state: RootState) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.members_fl;

export const SELECT_APPLICATIONS_DATA_TO_BANK_MEMBER_UL = (state: RootState) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.members_ul;

export const SELECT_APPLICATIONS_DATA_TO_BANK_ACCOUNTING_BALANCE = (
  state: RootState
) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.balance_application
    ?.accountingBalance;

export const SELECT_APPLICATIONS_DATA_TO_BANK_BALANCE = (state: RootState) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.balance_application;

export const SELECT_APPLICATIONS_DATA_TO_BANK_FINANCEDOCUMENTS = (
  state: RootState
) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.documents
    ?.financeDocument;

export const SELECT_APPLICATIONS_DATA_TO_BANK_MAINDOCUMENTS = (
  state: RootState
) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.documents?.mainDocument;

export const SELECT_APPLICATIONS_DATA_TO_BANK_PASPORTDOCUMENTS = (
  state: RootState
) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.documents
    ?.pasportDocument;

export const SELECT_APPLICATIONS_DATA_TO_BANK_STOP_FACTORS = (
  state: RootState
) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.scoring_result?.data
    ?.stopFactors;

export const SELECT_APPLICATIONS_DATA_TO_BANK_BUSINESS_RISKS = (
  state: RootState
) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.scoring_result?.data
    ?.businessRisks;

export const SELECT_APPLICATIONS_DATA_TO_BANK_CREDITWORTHINESS = (
  state: RootState
) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.scoring_result?.data
    ?.creditworthiness;

export const SELECT_APPLICATIONS_DATA_TO_BANK_COMMENT_STOP_FACTORS = (
  state: RootState
) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.scoring_result?.data
    ?.commentStopFactors;

export const SELECT_APPLICATIONS_DATA_TO_BANK_COMMENT_BUSINESS_RISKS = (
  state: RootState
) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.scoring_result?.data
    ?.commentBusinessRisks;

export const SELECT_APPLICATIONS_DATA_TO_BANK_COMMENT_CREDITWORTHINESS = (
  state: RootState
) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.scoring_result?.data
    ?.commentCreditworthiness;

export const SELECT_APPLICATIONS_DATA_TO_BANK_COMMENT_SETTLEMENT_RATING = (
  state: RootState
) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.scoring_result?.data
    ?.commentSettlementRating;

export const SELECT_APPLICATIONS_DATA_TO_BANK_LEAD_USER = (state: RootState) =>
  state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.lead_user;

export const SELECT_APPLICATIONS_DATA_TO_BANK_RESPONSIBLE_USER = (
  state: RootState
) => state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.responsible_user;

export const SELECT_APPLICATIONS_DATA_TO_BANK_EMPLOYEE_USER = (
  state: RootState
) => state.applicationBankSlice.APPLICATION_DATA_TO_BANK?.employee_user;
export const SELECT_SIGN_INFO_MODAL = (state: RootState) =>
  state.applicationBankSlice.signInfoModal;
